import { NgModule } from '@angular/core';
import { AmdWindowRefModule } from '../window-ref/window-ref.module';
import { AmdMediaQuery } from './media-query.constant';
import { AMD_MEDIA_QUERY } from './media-query.token';
import { AmdMediaQueryService } from './media-query.service';
export class AmdMediaQueryModule {
}
AmdMediaQueryModule.decorators = [
    { type: NgModule, args: [{
                imports: [AmdWindowRefModule],
                providers: [
                    { provide: AMD_MEDIA_QUERY, useValue: AmdMediaQuery },
                    AmdMediaQueryService
                ]
            },] },
];
/**
 * @nocollapse
 */
AmdMediaQueryModule.ctorParameters = () => [];
function AmdMediaQueryModule_tsickle_Closure_declarations() {
    /** @type {?} */
    AmdMediaQueryModule.decorators;
    /**
     * @nocollapse
     * @type {?}
     */
    AmdMediaQueryModule.ctorParameters;
}
//# sourceMappingURL=media-query.module.js.map
//# sourceMappingURL=media-query.module.js.map
